import React, { useEffect } from 'react'
import { Modal } from '../Modal/Modal'
import { CommmandNav } from './components/CommandNav'
import { useCommandMenuOpen } from './hooks/useCommandMenuOpen'
import './styles/Command.scss'
import './styles/CommandMenu.scss'

const isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)
const isQuickAction = (e: KeyboardEvent) =>
  isMacLike ? e.key === '/' && e.metaKey : e.key === '/' && e.ctrlKey
const isQuickSave = (e: KeyboardEvent) =>
  isMacLike ? e.key === 's' && e.metaKey : e.key === 's' && e.ctrlKey

export const CommandMenu = () => {
  const { isOpen, setIsOpen } = useCommandMenuOpen()

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (isQuickAction(e)) {
        setIsOpen((open) => !open)
      }
      if (isQuickSave(e)) {
        const form = document.querySelector('form')
        if (form) {
          e.preventDefault()
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
        }
      }
    }

    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [setIsOpen])

  return (
    <Modal open={isOpen} placement="top" blur="2px" onOpenChange={setIsOpen}>
      <div className="modal-body p-0">
        <CommmandNav onReroute={() => setIsOpen(false)} />
      </div>
    </Modal>
  )
}

export const CommandKeys = () => {
  if (isMacLike) {
    return <span className="font-monospace">⌘ + /</span>
  }
  return <span className="font-monospace">Ctrl + /</span>
}
